import React, { useCallback, useState } from 'react';
import isNil from 'lodash-es/isNil';

import { TrackingType } from '~/src/common/consumption/completion-snackbar';

import type { ExtendedBrightcovePlayer } from '../types';

import { CompletionSnackbar } from '../../CompletionSnackbar/CompletionSnackbar';
import {
  convertSecondsInMinutes,
  getMediaDurationInMinutes,
  getMediaDurationInSeconds,
  getTimeInSeconds,
  useSecondConsumed,
} from '../media-lifecycle-hooks';
import { useMediaPlayer } from '../MediaPlayerProvider';

/**
 * the logic is transfered from legacy part
 * - the definition of 'media complete' should be improved in the future
 * - the code below can be refactore after JWPlayer removal
 */
const isMediaComplete = ({
  consumedSeconds,
  player,
}: {
  consumedSeconds: number;
  player: ExtendedBrightcovePlayer;
}): boolean => {
  const mediaDurationMinutes = getMediaDurationInMinutes(player);
  const totalMinutesConsumed = convertSecondsInMinutes(consumedSeconds);
  const completionPercent = Math.ceil((totalMinutesConsumed / mediaDurationMinutes) * 100);
  const isAmlostCompleted = completionPercent > 95;

  const currentTimeInSec = getTimeInSeconds(player);
  const mediaDurationInSeconds = getMediaDurationInSeconds(player);
  const isLeftLessThan5Second = mediaDurationInSeconds - currentTimeInSec <= 5;

  const isComplete = isAmlostCompleted && isLeftLessThan5Second;
  return isComplete;
};

export const Snackbar: React.FC<{ trackingType: TrackingType }> = ({ trackingType }) => {
  const [showSnackbar, setShowSnackbar] = useState<'CLOSED' | 'OPEN' | 'DISMISSED'>('CLOSED');

  const { player } = useMediaPlayer();
  const cb = useCallback(() => {
    if (player !== null) {
      const consumedSeconds = player.consumedSeconds();
      const isComplete = isMediaComplete({ consumedSeconds, player });
      if (isComplete && showSnackbar === 'CLOSED' && trackingType !== 'LIVE') {
        setShowSnackbar('OPEN');
      }
    }
  }, [player, showSnackbar, trackingType]);

  useSecondConsumed(cb);

  if (isNil(trackingType)) {
    return null;
  }
  return (
    <CompletionSnackbar
      show={showSnackbar === 'OPEN'}
      onClose={() => setShowSnackbar('DISMISSED')}
      contentType={trackingType}
    />
  );
};
